export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1757359056339-22968344cce6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwZXh0ZXJpb3IlMjBkdXNrJTIwd2FybSUyMGxpZ2h0c3xlbnwwfHx8fDE3ODQ4NjI5ODh8MA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1757356657991-c3fd6e2e812e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwZXh0ZXJpb3IlMjBkdXNrJTIwd2FybSUyMGxpZ2h0c3xlbnwwfHx8fDE3ODQ4NjI5ODh8MA&ixlib=rb-4.1.0&q=85",
  events: "https://images.unsplash.com/photo-1653821355226-6def361cc7ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwZ2FsYSUyMGV2ZW50JTIwbmlnaHQlMjBsaWdodHN8ZW58MHx8fHwxNzgzMzk1MDczfDA&ixlib=rb-4.1.0&q=85",
  concierge: "https://images.unsplash.com/photo-1768346564233-d71f37bd19b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBsaWZlc3R5bGUlMjBjb25jaWVyZ2UlMjBwcml2YXRlJTIwamV0JTIwY2hhbXBhZ25lfGVufDB8fHx8MTc4MzM5NTA3M3ww&ixlib=rb-4.1.0&q=85",
  settlement: "https://images.unsplash.com/photo-1733244766159-f58f4184fd38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZWxvY2F0aW9uJTIwbmV3JTIwaG9tZSUyMGtleXMlMjBtb2Rlcm58ZW58MHx8fHwxNzgzOTA1ODc2fDA&ixlib=rb-4.1.0&q=85",
  investment: "https://images.unsplash.com/photo-1712873068978-eb0cb20d1b62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxpbnRlcm5hdGlvbmFsJTIwZmluYW5jZSUyMGNpdHklMjBza3lsaW5lJTIwaW52ZXN0bWVudHxlbnwwfHx8fDE3ODM5MDU4NzZ8MA&ixlib=rb-4.1.0&q=85",
  festival: "https://images.unsplash.com/photo-1505147634308-9b83c4cb46b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwY3VsdHVyZSUyMGZlc3RpdmFsJTIwY2VsZWJyYXRpb24lMjBjcm93ZCUyMGNvbG9yZnVsfGVufDB8fHx8MTc5MTY5MjQ4NHww&ixlib=rb-4.1.0&q=85",
  gallery: [
    "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwaW50ZXJpb3IlMjBicmlnaHR8ZW58MHx8fHwxNzg0ODYzMzkwfDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1709014488957-bd321385b8a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxDYW5hZGElMjBjaXR5JTIwc2t5bGluZSUyMG1vZGVybnxlbnwwfHx8fDE3ODQ4NjMzOTB8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwaW50ZXJpb3IlMjBicmlnaHR8ZW58MHx8fHwxNzg0ODYzMzkwfDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1768346564233-d71f37bd19b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBsaWZlc3R5bGUlMjBjb25jaWVyZ2UlMjBwcml2YXRlJTIwamV0JTIwY2hhbXBhZ25lfGVufDB8fHx8MTc4MzM5NTA3M3ww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwaW50ZXJpb3IlMjBicmlnaHR8ZW58MHx8fHwxNzg0ODYzMzkwfDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1662099782192-f7ba7bf67236?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxDYW5hZGElMjBjaXR5JTIwc2t5bGluZSUyMG1vZGVybnxlbnwwfHx8fDE3ODQ4NjMzOTB8MA&ixlib=rb-4.1.0&q=85",
  ],
};

export const EVENT = {
  name: "Newcomers Afro Urban Festival",
  year: "2027",
  location: "Saskatoon, SK",
  pillars: ["Music", "Food", "Fashion", "Business Networking"],
  lead: "Celebrating Culture · Connecting People · Building Opportunities",
  blurb: "A vibrant celebration of culture, community and opportunity — bringing newcomers and diverse communities together across Canada.",
  details: [
    { label: "Date", value: "August 2027 (TBC)" },
    { label: "Venue", value: "To be announced — Saskatoon, SK" },
    { label: "Attendance", value: "300 – 500 guests" },
    { label: "Admission", value: "Free" },
  ],
  highlights: [
    { icon: "Music", title: "Music", body: "Live performances, DJ sets & cultural showcases." },
    { icon: "UtensilsCrossed", title: "Food", body: "Authentic African and global cuisine & food vendors." },
    { icon: "Shirt", title: "Fashion", body: "Afro-inspired fashion show, vendors & designers." },
    { icon: "Users", title: "Networking", body: "Business connections, entrepreneurship & opportunities." },
  ],
  whySponsor: [
    "Showcase your brand to a diverse and engaged audience",
    "Support newcomer integration and cultural diversity",
    "Build meaningful community relationships",
    "Gain visibility through multi-channel promotion",
    "Access business networking and activation opportunities",
  ],
  packages: [
    {
      tier: "Presenting Partner",
      price: "$15,000",
      featured: true,
      perks: ['"Presented by" recognition', "Premium logo placement (stage, media, website)", "Main stage acknowledgments", "Premium activation space", "Social media and PR exposure"],
    },
    {
      tier: "Gold Partner",
      price: "$7,500",
      perks: ["Prominent logo placement", "Activation booth / display space", "Stage mentions and program listing", "Social media recognition"],
    },
    {
      tier: "Silver Partner",
      price: "$3,000",
      perks: ["Logo on event materials", "Booth or display option", "Event acknowledgments"],
    },
    {
      tier: "Community Partner",
      price: "$1,000",
      perks: ["Website and social recognition", "Acknowledgment in event program"],
    },
    {
      tier: "Supporting Partner",
      price: "$500",
      perks: ["Name listed among supporting sponsors", "Post-event appreciation"],
    },
    {
      tier: "In-Kind Partner",
      price: "$500 – $7,500",
      note: "equivalent value",
      perks: ["Venue, equipment, food, printing, media and more"],
    },
  ],
};


export const SERVICES = [
  {
    id: "settlement",
    title: "Premium Settlement Services",
    tagline: "Arrive, and belong",
    body: "Relocating across borders, handled end to end. We manage immigration, luxury housing, schooling and every logistical detail so you and your family settle seamlessly into your new life.",
    points: ["Immigration & Visa Support", "Luxury Home Sourcing", "Family & School Placement", "Full Relocation Logistics"],
    image: IMAGES.settlement,
    span: "lg:col-span-7",
  },
  {
    id: "investment",
    title: "International Investment & Travel Concierge",
    tagline: "Wealth & journeys, without borders",
    body: "Access curated global opportunities and effortless world travel with a partner who moves with discretion. From prime real estate and cross-border ventures to private itineraries and exclusive stays, we open doors worldwide.",
    points: ["Global Real Estate & Ventures", "Citizenship by Investment", "Private & Luxury Travel", "Bespoke International Itineraries"],
    image: IMAGES.investment,
    span: "lg:col-span-5",
  },
  {
    id: "events",
    title: "Premium Events",
    tagline: "Occasions, elevated",
    body: "Signature celebrations and private gatherings, designed and produced end to end. From concept and styling to flawless execution, we create premium events that leave a lasting impression.",
    points: ["Private Celebrations", "Milestone & Cultural Events", "Styling & Production", "Full Event Management"],
    image: IMAGES.events,
    span: "lg:col-span-12",
  },
];

export const SECONDARY = [
  {
    id: "experiences",
    title: "Bespoke Experiences",
    body: "Thoughtfully planned, one-of-a-kind experiences designed intimately around you — never off the shelf.",
  },
  {
    id: "concierge",
    title: "Lifestyle & Luxury Concierge",
    body: "A discreet, always-on concierge for reservations, access and the everyday details.",
  },
];

export const STATS = [
  { value: "500+", label: "Families Relocated" },
  { value: "12", label: "Years of Craft" },
  { value: "40+", label: "Cities Worldwide" },
  { value: "98%", label: "Client Return Rate" },
];

export const TESTIMONIALS = [
  {
    quote:
      "9jaclicks made our move to Canada feel effortless. Visas, our home, the children's school — everything was handled before we even arrived. We simply landed and began our new life.",
    author: "Adaeze O.",
    role: "Family Relocation, Saskatoon",
  },
  {
    quote:
      "Their investment and travel concierge is in a league of its own. They opened doors to opportunities and journeys I couldn't have accessed alone. Discretion and excellence, always.",
    author: "Tunde A.",
    role: "International Investment Client",
  },
  {
    quote:
      "From immigration paperwork to sourcing the perfect home, every detail was anticipated. 9jaclicks didn't just relocate us — they helped us belong.",
    author: "Chidinma E.",
    role: "Settlement Client",
  },
];
